import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserData } from "app/shared/service/UserService";
import { CryptoService } from "app/shared/utils/crypto.service";
import { BehaviorSubject, Observable, Subject, catchError, defer, from, lastValueFrom, of, switchMap, tap } from "rxjs";
import * as _ from "underscore";

@Injectable({
  providedIn: "root",
})
export class AnalyticService {
  private apiUrl: string;
  private header;
  private headerAppJSON;
  private crypto: CryptoService;

  constructor(private http: HttpClient) {
    this.apiUrl = UserData.backend_url + "/v1";
    this.header = this.getHeader();
    this.headerAppJSON = this.getHeaderAppJSON();
  }

  public getHeader() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
      }),
    };
    return httpOptions;
  }

  public getHeaderAppJSON() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
        "Content-Type": "application/json",
      }),
    };
    return httpOptions;
  }

  public getAnalyticsForTeamsAndUsers() {
    const url = this.apiUrl + "/analytics/userAndTeamUsage";
    return this.http.get(url, this.header);
  }

  public getAnalyticsForPSetsAndFolders(gameId) {
    const url = this.apiUrl + "/analytics/practiceSetAndFolderUsage?gameId=" + gameId;
    return this.http.get(url, this.header);
  }

  public getDifficultPSets(gameId, dataID?: string) {
    const url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?gameId=" + gameId + (dataID ? "&dataId=" + dataID : "");
    return this.http.get(url, this.header);
  }

  public getPracticeSetData(data, gameId, userName, dataID?: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?day=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    else if (data == "month")
      url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?month=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    else if (data == "year")
      url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?year=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public starsLessonAnalyticsUsageCount(data, gameId, userName, dataID?: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/stars/analytics/starsLessonAnalyticsUsageCount?day=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    else if (data == "month")
      url = this.apiUrl + "/stars/analytics/starsLessonAnalyticsUsageCount?month=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    else if (data == "year")
      url = this.apiUrl + "/stars/analytics/starsLessonAnalyticsUsageCount?year=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public starsLessonAnalyticsSessionData(data, gameId, userName, dataID?: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/stars/analytics/starsLessonAnalyticsSessionData?day=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    else if (data == "month")
      url = this.apiUrl + "/stars/analytics/starsLessonAnalyticsSessionData?month=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    else if (data == "year")
      url = this.apiUrl + "/stars/analytics/starsLessonAnalyticsSessionData?year=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getcommandTypeAnalytics(data, gameId, userName, commandType: string, dataID?: string, folderId?: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/atc/analytics/commandTypeAnalytics?day=" + data + "&gameId=" + gameId + (commandType ? "&commandType=" + commandType : "") + (dataID ? "&dataId=" + dataID : "") + (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "month")
      url = this.apiUrl + "/atc/analytics/commandTypeAnalytics?month=" + data + "&gameId=" + gameId + (commandType ? "&commandType=" + commandType : "")+ (dataID ? "&dataId=" + dataID : "") + (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "year")
      url = this.apiUrl + "/atc/analytics/commandTypeAnalytics?year=" + data + "&gameId=" + gameId + (commandType ? "&commandType=" + commandType : "") + (dataID ? "&dataId=" + dataID : "") + (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getconsolidatedRatioData(data, gameId, userName, dataID?: string, folderId?: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/atc/analytics/consolidatedrecord?day=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "")+ (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "month")
      url = this.apiUrl + "/atc/analytics/consolidatedrecord?month=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "")+ (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "year")
      url = this.apiUrl + "/atc/analytics/consolidatedrecord?year=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "")+ (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getconsolidatedTotalData(data, gameId, userName, dataID?: string, folderId?: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/atc/analytics/consolidatedrecordTotal?day=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "")+ (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "month")
      url = this.apiUrl + "/atc/analytics/consolidatedrecordTotal?month=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "year")
      url = this.apiUrl + "/atc/analytics/consolidatedrecordTotal?year=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "")+ (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getStarsConsolidatedTotalData(data, gameId, userName, dataID?: string, folderId?: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/stars/analytics/consolidatedrecordTotal?day=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "")+ (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "month")
      url = this.apiUrl + "/stars/analytics/consolidatedrecordTotal?month=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    else if (data == "year")
      url = this.apiUrl + "/stars/analytics/consolidatedrecordTotal?year=" + data + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "")+ (folderId ? "&folderId=" + folderId : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getDifficultPOnDateRangeConsolidatedRatio(fromDate, toDate, gameId, userName, dataID?: string, folderId?: string) {
    const url =
      this.apiUrl +
      "/atc/analytics/consolidatedrecord?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (folderId ? "&folderId=" + folderId : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getDifficultPOnDateRangeConsolidatedTotal(fromDate, toDate, gameId, userName, dataID?: string, folderId?: string) {
    const url =
      this.apiUrl +
      "/atc/analytics/consolidatedrecordTotal?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (folderId ? "&folderId=" + folderId : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getStarsDifficultPOnDateRangeConsolidatedTotal(fromDate, toDate, gameId, userName, dataID?: string, folderId?: string) {
    const url =
      this.apiUrl +
      "/stars/analytics/consolidatedrecordTotal?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (folderId ? "&folderId=" + folderId : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getDifficultPOnDateRangeSets(fromDate, toDate, gameId, userName, dataID?: string) {
    const url =
      this.apiUrl +
      "/analytics/practiceSetDifficultyUsage?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public starsLessonAnalyticsUsageCountDateRange(fromDate, toDate, gameId, userName, dataID?: string) {
    const url =
      this.apiUrl +
      "/stars/analytics/starsLessonAnalyticsUsageCount?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public starsLessonAnalyticsSessionDataDateRange(fromDate, toDate, gameId, userName, dataID?: string) {
    const url =
      this.apiUrl +
      "/stars/analytics/starsLessonAnalyticsSessionData?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getCommandTypeAnalyticsDateRangeSets(fromDate, toDate, gameId, userName, commandType: string, dataID?: string, folderId?: string) {
    const url =
      this.apiUrl +
      "/atc/analytics/commandTypeAnalytics?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId + (commandType ? "&commandType=" + commandType : "") +
      (dataID ? "&dataId=" + dataID : "") +
      (folderId ? "&folderId=" + folderId : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }


  public getLessonRecords(data: any, lessonId: any, userName: any) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/analytics/eramLessonAnalyticsUsageCount?day=" + data + "&lessonId=" + lessonId + (userName ? "&selectedUserName=" + userName : "");
    else if (data == "month") url = this.apiUrl + "/analytics/eramLessonAnalyticsUsageCount?month=" + data + "&lessonId=" + lessonId + (userName ? "&selectedUserName=" + userName : "");
    else if (data == "year") url = this.apiUrl + "/analytics/eramLessonAnalyticsUsageCount?year=" + data + "&lessonId=" + lessonId + (userName ? "&selectedUserName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getLessonRecordsOnDateRangeSets(fromDate: any, toDate: any, lessonId: any, userName: any) {
    const url = this.apiUrl + "/analytics/eramLessonAnalyticsUsageCount?fromDate=" + fromDate + "&toDate=" + toDate + "&lessonId=" + lessonId + (userName ? "&selectedUserName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByDay(date, gameId, userName, dataID?: string, usageType?: string) {
    if(!date) return new Subject();
    const url =
      this.apiUrl +
      "/analytics/sessionsPlayedUsage?fromDate=" +
      date +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "") +
      (!_.isUndefined(usageType) && usageType != null ? "&selectedUsageType=" + usageType : "");
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByMonth(date, gameId, userName, dataID?: string, usageType?: string) {
    const url =
      this.apiUrl +
      "/analytics/sessionsPlayedMonths?fromDate=" +
      date +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "") +
      (!_.isUndefined(usageType) && usageType != null ? "&selectedUsageType=" + usageType : "");
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByYear(date, gameId, userName, dataID?: string, usageType?: string) {
    const url =
      this.apiUrl + "/analytics/sessionsPlayedYear?fromDate=" +
      date +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "") +
      (!_.isUndefined(usageType) && usageType != null ? "&selectedUsageType=" + usageType : "");
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByDateRange(fromDate, toDate, gameId, userName, dataID?: string, usageType?: string) {
    const url =
      this.apiUrl +
      "/analytics/sessionsPlayedCustomRange?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "") +
      (!_.isUndefined(usageType) && usageType != null ? "&selectedUsageType=" + usageType : "");
    return this.http.get(url, this.header);
  }

  //Masterd Practice Set

  public getMasteredPracticeSetByDay(date, gameId, userName, dataID?: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedMasteredUsage?fromDate=" + date + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getMasteredPracticeSetByMonth(date, gameId, userName, dataID?: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedMasteredMonths?fromDate=" + date + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getMasteredPracticeSetByYear(date, gameId, userName, dataID?: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedMasteredYear?fromDate=" + date + "&gameId=" + gameId + (dataID ? "&dataId=" + dataID : "") + (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getMasteredPracticeSetByDateRange(fromDate, toDate, gameId, userName, dataID?: string) {
    const url =
      this.apiUrl + "/analytics/sessionsPlayedMasteredCustomRange?fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&gameId=" +
      gameId +
      (dataID ? "&dataId=" + dataID : "") +
      (userName ? "&userName=" + userName : "");
    return this.http.get(url, this.header);
  }

  public getLastActiveUsers(fromDate, toDate, flag) {
    let url: any = "";
    if (flag) url = this.apiUrl + "/analytics/lastActiveUsersDetailRange";
    else url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getActiveUsersData(type, data) {
    let url: any = "";
    if (type == "day") url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?day=" + data;
    else if (type == "month") url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?month=" + data;
    else if (type == "year") url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?year=" + data;
    return this.http.get(url, this.header);
  }

  public getCsvData(analyticType: any, selectedDateType: any, startDate: any, endDate: any, gameId, usageType: string, userName, dataID?: string): Observable<Blob> {
    let url: any = "";

    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url =
          this.apiUrl +
          "/generalAnalytics/recordUsage?analyticsType=" +
          analyticType +
          "&usageType=" +
          selectedDateType +
          "&gameId=" +
          gameId +
          usageType +
          (dataID ? "&dataId=" + dataID : "") +
          (userName ? "&userName=" + userName : "");
      } else {
        url =
          this.apiUrl +
          "/generalAnalytics/recordUsage?analyticsType=" +
          analyticType +
          "&fromDate=" +
          startDate +
          "&toDate=" +
          endDate +
          "&gameId=" +
          gameId +
          usageType +
          (dataID ? "&dataId=" + dataID : "") +
          (userName ? "&userName=" + userName : "");
      }
    }

    return this.http.get(url, { responseType: "blob" });
  }

  public starsLessonAnalyticsUsageCountExport(selectedDateType: any, startDate: any, endDate: any, gameId, usageType: string, userName, dataID?: string): Observable<Blob> {
    let url: any = "";

      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url =
          this.apiUrl +
          "/stars/analytics/starsLessonAnalyticsUsageCountExport?" + selectedDateType + "=" +
          selectedDateType +
          "&gameId=" +
          gameId +
          usageType +
          (dataID ? "&dataId=" + dataID : "") +
          (userName ? "&userName=" + userName : "");
      } else {
        url =
          this.apiUrl +
          "/stars/analytics/starsLessonAnalyticsUsageCountExport?fromDate=" +
          startDate +
          "&toDate=" +
          endDate +
          "&gameId=" +
          gameId +
          usageType +
          (dataID ? "&dataId=" + dataID : "") +
          (userName ? "&userName=" + userName : "");
      }   

    return this.http.get(url, { responseType: "blob" });
  }

  public thisWeekUsersList(userType: string) {
    let url: any = this.apiUrl + "/analytics/thisWeekUsersList?userType=" + userType;
    return this.http.get(url, this.header);
  }

  public consolidatedrecordExport(selectedDateType: any, startDate: any, endDate: any, gameId, usageType: string, userName, dataID?: string, folderId?: string): Observable<Blob> {
    let url: any = "";
   
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url =
          this.apiUrl +
          "/atc/analytics/consolidatedrecordExport?" + selectedDateType + "=" +
          selectedDateType +
          "&gameId=" +
          gameId +
          usageType +
          (dataID ? "&dataId=" + dataID : "") +
          (folderId ? "&folderId=" + folderId : "") +
          (userName ? "&userName=" + userName : "");
      } else {
        url =
          this.apiUrl +
          "/atc/analytics/consolidatedrecordExport?fromDate=" +
          startDate +
          "&toDate=" +
          endDate +
          "&gameId=" +
          gameId +
          usageType +
          (dataID ? "&dataId=" + dataID : "") +
          (userName ? "&userName=" + userName : "");
      }
    

    return this.http.get(url, { responseType: "blob" });
  }
}
